import NewDocument from './NewDocument';
import NewLink from './NewLink';

type NewRecordsProps = {
    disabled?: boolean;
    folderId: string;
    onCreate?: (id?: string) => void;
};

function NewRecords({ disabled = false, folderId, onCreate }: NewRecordsProps): JSX.Element {
    return (
        <div className="flex items-center">
            <NewDocument
                disabled={disabled}
                folderId={folderId}
                onCreate={(id): void => {
                    if (onCreate) {
                        onCreate(id);
                    }
                }}
            />
            <NewLink
                disabled={disabled}
                folderId={folderId}
                onCreate={(id): void => {
                    if (onCreate) {
                        onCreate(id);
                    }
                }}
            />
        </div>
    );
}

export default NewRecords;
